import { initializeOidcEarly } from '@newton-monorepo/oidc-auth/early-init';

import { getOidcBaseUrl } from './oidc-base-url';

const oidcBaseUrl =
  typeof document === 'undefined'
    ? undefined
    : getOidcBaseUrl(document.location.pathname);

if (initializeOidcEarly(oidcBaseUrl)) {
  import('./main.lazy').catch((err) => console.error(err));
}
